import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_PLACEHOLDER } from './../../../const/icons';

import { COMP_BUTTON_PLACEHOLDER } from './../../../const/components';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const Placeholder = (editor, options:any = {}) => {

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_PLACEHOLDER,
    displayIcon: ICON_BUTTON_PLACEHOLDER,
    model: {
      defaults: { ...Defaults,
        name: 'Placeholder',
        traits: [ ...Traits]
      }
    }
  });
}